// Applicant status constants matching the backend enum
export const ApplicantStatus = {
    Applied: 0,
    Scored: 1,
    RejectedAutomatically: 2,
    RejectedManually: 3,
    Shortlisted: 4,
    SelectedForInterview: 5,
    HrReview: 6,
    ToBeHired: 7
};

// Readable labels for display
export const ApplicantStatusLabels = {
    [ApplicantStatus.Applied]: "Applied",
    [ApplicantStatus.Scored]: "Scored",
    [ApplicantStatus.RejectedAutomatically]: "Rejected Automatically",
    [ApplicantStatus.RejectedManually]: "Rejected Manually",
    [ApplicantStatus.Shortlisted]: "Shortlisted",
    [ApplicantStatus.SelectedForInterview]: "Selected For Interview",
    [ApplicantStatus.HrReview]: "HR Review",
    [ApplicantStatus.ToBeHired]: "To Be Hired"
};

// Helper function to get readable label from status value
export const getApplicantStatusLabel = (status) => {
    // Handle null, undefined, and empty values
    if (status === null || status === undefined || status === '') {
        return 'Not Set';
    }
    
    // Handle enum name strings (e.g., "RejectedAutomatically")
    if (typeof status === 'string' && ApplicantStatus[status] !== undefined) {
        return ApplicantStatusLabels[ApplicantStatus[status]];
    }
    
    // Handle both string and number inputs
    const statusValue = typeof status === 'string' ? parseInt(status, 10) : status;
    
    // Check if the parsed value is a valid number
    if (isNaN(statusValue)) {
        return `Invalid Status (${status})`;
    }
    
    return ApplicantStatusLabels[statusValue] || `Unknown (${status})`;
};

// Helper function to get status value from readable label
export const getApplicantStatusValue = (label) => {
    const entry = Object.entries(ApplicantStatusLabels).find(([_, value]) => value === label);
    return entry ? parseInt(entry[0]) : null;
};

// Options for select components
export const ApplicantStatusOptions = Object.entries(ApplicantStatusLabels).map(([value, label]) => ({
    value: parseInt(value),
    label: label
}));

// Options object for ReactTableFilterSelect (key-value pairs)
// Use labels as keys to match the original working approach
export const ApplicantStatusFilterOptions = Object.entries(ApplicantStatusLabels).reduce((acc, [value, label]) => {
    acc[label] = label;
    return acc;
}, { "": "Show All" });
